import React from "react";
import { NavLink } from "react-router-dom";

function BannerHomepage() {
  return (
    <section className="section-banner-homepage">
      <div className="banner-content-container">
        <div className="banner-left-content">
          <h1 className="banner-title">Yesshop</h1>
          <p className="banner-tagline">
            Votre marketplace de
            <br />
            confiance
          </p>
          <NavLink className="btn btn-banner-decouvrir" to="/produits">
            DÉCOUVREZ NOS PRODUITS
          </NavLink>
        </div>
      </div>

      <div className="banner-promo-strip">
        <div className="banner-promo-content">
          <span>Livraison rapide</span>
          <span className="promo-separator">|</span>
          <span>Retours faciles</span>
          <span className="promo-separator">|</span>
          <span>Achat sécurisé</span>
          <span className="promo-separator">|</span>
          <span>Offres exclusives</span>
        </div>
      </div>
    </section>
  );
}

export default BannerHomepage;
